import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DataService, Loading } from 'src/app/Services/Data/data.service';

@Component({
  selector: 'app-list-builder',
  templateUrl: './list-builder.component.html',
  styleUrls: ['./list-builder.component.css']
})
export class ListBuilderComponent implements OnInit {
  // attachments
  attachments: any = [];
  selectedAttachmentList: any = [];
  // user login
  login = false;
  user_data: any;

  // Loading
  loading: Loading;

  // error
  error_messages: any = [];
  // Data
  data: any = [];
  salesforce: any = [];
  document_group: any = [];
  //Salesforce Session
  salesforce_session_data: any;

  //Conditionals
  okayToUploadAtachments: boolean = false;

  constructor(private router: Router, private dataService: DataService) {
    this.loading = dataService.getLoading();
  }

  ngOnInit() {
    this.load();
  }

  loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
  }

  searchAttachments(value, tableId: string) {
    const filter = value.toUpperCase();
    const tr = this.LoadTableColumnsGivenTableId(tableId);
    this.LoopThroughtTheTableAndFilterFirstTwoColumns(tr, filter);
  }

  addToAttachmentGroup(attachment, event) {
    let selectedAttachmentCount;
    if (event.target.checked) {
      this.selectedAttachmentList.push(attachment);
      selectedAttachmentCount = this.selectedAttachmentList.length;
    } else {
      this.removeAttachmentFromGroup(attachment);
      selectedAttachmentCount = this.selectedAttachmentList.length;
    }
    if (selectedAttachmentCount >= 2) {
      this.setOkayToUploadAttachment(true);
    } else {
      this.setOkayToUploadAttachment(false);
    }
  }

  removeAttachmentFromGroup(attachment) {
    let found = false;
    for (let i = 0; i < this.selectedAttachmentList.length && !found; i++) {
      let attachmentId = this.selectedAttachmentList[i].id;
      let attachmentIdToRemove = attachment.id;
      if (attachmentId === attachmentIdToRemove) {
        this.selectedAttachmentList.splice(i, 1);
        found = true;
      }
    }
  }

  async loadSalesforceDataIntoDataService() {
    this.ifValidSession(() => {
      this.processedToLoadSalesforceDataIntoDataService();
    });
  }

  async ifValidSession(callback) {
    await this.getSalesforceSessionDataFromBackend();
    if (this.checkIfSessionIsNotValid()) {
      this.invalidSalesforceSessionDisplayLoginAndError();
    } else {
      callback();
    }
  }

  getRecordEmails(record_type, instance_url, sf_token) {
    const data = this.configureGetEmailsApiParameter(sf_token, instance_url, record_type);
    this.getSalesforceRecordsEmails(data).subscribe((result) => {
      this.loadEmailsAndSetDataServiceWithEmailRecords(result);
    });
  }

  async loadSalesforceDataFromParentFrameAndUpdateUserDB() {
    try {
      await this.processLoadSalesforceDataFromParentFrameAndUpdateUserDB();
    } catch {}
  }

  validValue(value): boolean {
    if (value === null || value === undefined || typeof value === 'undefined') {
      return false;
    }
    return true;
  }

  loadAttachmentList() {
    const { attachment_selected, selected_attachment_id } = this.checkIfPreselectedAttachmentIsProvided();
    const data = this.setupGetAttachmentListApiDataParameter();
    this.getAttachmentList(data).subscribe((result) => {
      this.processGetAttachmentListResponse(result, attachment_selected, selected_attachment_id);
    });
  }

  convertTime(timestamp) {
    const { month, min, date, year, hour } = this.getDateTimeParametersGivenTimeStamp(timestamp);
    return this.generateDateTimeString(min, date, month, year, hour);
  }

  sendAttachmentToSignnow(attachment) {
    const data = this.initAndSetupPostToAttachmentSignNowApiDataParameter(attachment);
    this.updateLoading(true, 'Sending attachment to Signnow.');
    this.postAttachmentToSignNowAndProcessResponse(data);
  }

  uploadAttachmentsToSignNow() {
    this.updateLoading(true, 'Sending attachments to Signnow.');

    const attachmentList = this.selectedAttachmentList;
    const dataList = [];

    for (let i = 0; i < attachmentList.length; i++) {
      const data = this.initAndSetupPostToAttachmentSignNowApiDataParameter(attachmentList[i]);
      dataList.push(data);
    }

    this.postAttachmentsToSignNowAndProcessResponse(dataList);
  }

  private postAttachmentsToSignNowAndProcessResponse(_dataList: any[]) {
    const data = { dataList: _dataList };

    this.postAttachmentsToSignNow(data).subscribe(
      (result) => {
        this.processPostAttachmentsToSignNowResult(result);
      },
      (error) => {
        this.updateLoading(false, '');

        if (error.status === 503 || error.status === 504) {
          this.updateError('Call timed out.');
        } else {
          this.updateError(error.error);
        }
      }
    );
  }

  private processPostAttachmentsToSignNowResult(result: any) {
    this.dataService.setAttachmentGroupDocIds(result);
    this.stopLoadingRedirectToNextStage();
  }

  private postAttachmentsToSignNow(data) {
    return this.dataService.apiPostCall('/api/post_attachments_to_signnow', data);
  }

  logout_user() {
    this.updateLoading(true, 'logging out user!');
    this.resetSignNowUserData();
    this.updateUserDBGivenUserData().subscribe(() => {
      this.stopLoadingAndSetLoginRequiredToTrue();
    });
  }

  reload() {
    this.load();
  }

  load() {
    this.setOkayToUploadAttachment(false);
    this.loadSalesforceDataIntoDataService();
    this.dataService.resetData();
    this.updateLoading(true, '');
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    this.loadInfo();
  }

  setOkayToUploadAttachment(state: boolean) {
    this.okayToUploadAtachments = state;
  }

  loginUser(email, password) {
    const login_data = {
      username: email,
      password: password
    };
    this.updateLoading(true, 'Requesting to login with SignNow.');
    this.loginToSignNow(login_data).subscribe((result) => {
      this.processLoginToSignNowResult(result, email);
    });
  }

  clearErrors() {
    this.error_messages = [];
  }

  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        this.error_messages.splice(i, 1);
      }
    }
  }

  private LoadTableColumnsGivenTableId(tableId: string) {
    const table = document.getElementById(tableId);
    const tr = table.getElementsByTagName('tr');
    return tr;
  }

  private LoopThroughtTheTableAndFilterFirstTwoColumns(tr: any, filter: any) {
    let td;
    let td2;
    for (let i = 0; i < tr.length; i++) {
      td = this.assignTdToFirstColumnDataInTable(td, tr, i);
      this.ApplySearchFilter(td, filter, tr, i);
      td2 = this.assignTd2ToSecondColumnDataInTable(td2, tr, i);
      this.ApplySearchFilter(td2, filter, tr, i);
    }
  }

  private ApplySearchFilter(td: any, filter: any, tr: NodeListOf<HTMLTableRowElement>, i: number) {
    if (td) {
      this.IfSearchFilterIsFoundDisplayOtherwiseHide(td, filter, tr, i);
    }
  }

  private assignTd2ToSecondColumnDataInTable(td2: any, tr: NodeListOf<HTMLTableRowElement>, i: number) {
    td2 = tr[i].getElementsByTagName('td')[1];
    return td2;
  }

  private IfSearchFilterIsFoundDisplayOtherwiseHide(
    td: any,
    filter: any,
    tr: NodeListOf<HTMLTableRowElement>,
    i: number
  ) {
    if (td.innerText.toUpperCase().indexOf(filter) > -1) {
      tr[i].style.display = '';
    } else {
      tr[i].style.display = 'none';
    }
  }

  private assignTdToFirstColumnDataInTable(td: any, tr: NodeListOf<HTMLTableRowElement>, i: number) {
    td = tr[i].getElementsByTagName('td')[0];
    return td;
  }

  private processedToLoadSalesforceDataIntoDataService() {
    const { sf_refresh, sf_token, sf_org_id, sf_user_id, instance_url, record_type, record_id, context } =
      this.setSessionDataToVariables();
    this.setSalesforceDataInTheDataService(
      sf_refresh,
      sf_token,
      sf_org_id,
      sf_user_id,
      instance_url,
      record_type,
      record_id,
      context
    );
    this.getRecordEmails(record_type, instance_url, sf_token);
  }

  private setSalesforceDataInTheDataService(
    sf_refresh: any,
    sf_token: any,
    sf_org_id: any,
    sf_user_id: any,
    instance_url: any,
    record_type: any,
    record_id: any,
    context: any
  ) {
    this.dataService.setSalesforceRefresh(sf_refresh);
    this.dataService.setSalesforceToken(sf_token);
    this.dataService.setSalesforceOrgId(sf_org_id);
    this.dataService.setSalesforceUserId(sf_user_id);
    this.dataService.setSalesforceInstanceUrl(instance_url);
    this.dataService.setSalesforceRecordType(record_type);
    this.dataService.setSalesforceRecordId(record_id);
    this.dataService.setSalesforceContext(context);
  }

  private invalidSalesforceSessionDisplayLoginAndError() {
    this.updateLoading(false, '');
    this.updateError(this.dataService.salesforce_session_error);
    this.attachments = [];
    this.login = true;
  }

  private async getSalesforceSessionDataFromBackend() {
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);
  }

  private setSessionDataToVariables() {
    const sf_token = this.salesforce_session_data.sf_token;
    const sf_refresh = this.salesforce_session_data.sf_refresh;
    const sf_org_id = this.salesforce_session_data.sf_org_id;
    const sf_user_id = this.salesforce_session_data.sf_user_id;
    const instance_url = this.salesforce_session_data.instance_url;
    const record_type = this.salesforce_session_data.record_type;
    const record_id = this.salesforce_session_data.record_id;
    const context = this.salesforce_session_data.context;
    return {
      sf_refresh,
      sf_token,
      sf_org_id,
      sf_user_id,
      instance_url,
      record_type,
      record_id,
      context,
      view: this.salesforce_session_data.view
    };
  }

  private configureGetEmailsApiParameter(sf_token: any, instance_url: any, record_type: any) {
    return { sf_token: sf_token, instance_url: instance_url, record_type: record_type };
  }

  private getSalesforceRecordsEmails(data: { sf_token: any; instance_url: any; record_type: any }) {
    return this.dataService.apiPostCall('/api/get_emails', data);
  }

  private loadEmailsAndSetDataServiceWithEmailRecords(result: any) {
    try {
      const res: any = JSON.parse(result);
      this.dataService.setRecordEmails(res);
    } catch {}
  }

  private async processLoadSalesforceDataFromParentFrameAndUpdateUserDB() {
    await this.ifValidSessionAsync();
    const { sf_refresh, sf_token, sf_org_id, sf_user_id, instance_url } = this.setSessionDataToVariables();
    this.checkUserDataInDbAndProccedLoading(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
  }

  private ifValidSessionAsync() {
    return new Promise<void>((resolve) => {
      this.ifValidSession(function () {
        resolve();
      });
    });
  }

  private checkUserDataInDbAndProccedLoading(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    this.setupUserDataGloablVariableForLoadingDataFromBackend(
      sf_user_id,
      sf_org_id,
      sf_token,
      sf_refresh,
      instance_url
    );
    this.updateLoading(true, "Checking validity of user's token.");
    this.checkIfUserInDbGivenSalesforceUserId(sf_user_id).subscribe((result) => {
      this.ifUserHasValidSNTokenUpdateDBWithData(result);
    });
  }

  private checkIfUserInDbGivenSalesforceUserId(sf_user_id: any) {
    return this.dataService.apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id);
  }

  private setupUserDataGloablVariableForLoadingDataFromBackend(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    this.user_data = {
      sf_user_id: sf_user_id,
      sn_token: '',
      sn_refresh: '',
      sf_org_id: sf_org_id,
      sf_token: sf_token,
      sf_refresh: sf_refresh,
      instance_url: instance_url
    };
  }

  private ifUserHasValidSNTokenUpdateDBWithData(data: any) {
    if (!(data.in_db == true && data.valid_sn_token == true)) {
      this.forceUsersToLoginBeforeContinuing();
    } else {
      this.validDataSetGlobalParametersUpdateDBGetAttachmentList(data);
    }
  }

  private validDataSetGlobalParametersUpdateDBGetAttachmentList(data: any) {
    this.setSNTokenAndRefreshToUserDataGlobalVariable(data);
    this.dataService.setSignNowOwnerEmail(data.sn_email);
    this.loadAttachmentList();
    this.updateUserDbIfUserDataSignNowTokenIsntEmpty();
  }

  private forceUsersToLoginBeforeContinuing() {
    this.loginRequired();
  }

  private loginRequired() {
    this.updateLoading(false, '');
    this.attachments = [];
    this.login = true;
  }

  private setSNTokenAndRefreshToUserDataGlobalVariable(data: any) {
    this.user_data.sn_token = data.sn_token;
    this.user_data.sn_refresh = data.sn_refresh;
  }

  private updateUserDbIfUserDataSignNowTokenIsntEmpty() {
    if (this.user_data.sn_token != '') {
      this.updateUserDBGivenUserData().subscribe(() => {});
    }
  }

  private checkIfSessionIsNotValid() {
    return !this.dataService.valid_salesforce_session(this.salesforce_session_data);
  }

  private processGetAttachmentListResponse(
    result: any,
    attachment_selected: boolean,
    selected_attachment_id: string
  ) {
    const { valid_attachments, valid_count } = this.buildValidAttachmentList(result);
    this.setGlobalAttachmentToLocalGeneratedValidAttachmentList(valid_attachments);
    this.ifSelectedInAttachmentListSendAttachmentToSignNow(
      valid_count,
      attachment_selected,
      selected_attachment_id
    );
    this.updateLoading(false, '');
  }

  private ifSelectedInAttachmentListSendAttachmentToSignNow(
    valid_count: number,
    attachment_selected: boolean,
    selected_attachment_id: string
  ) {
    for (let i = 0; i < valid_count; i++) {
      if (attachment_selected == true && this.attachments[i].Id == selected_attachment_id) {
        this.sendAttachmentToSignnow(this.attachments[i]);
      }
    }
  }

  private setGlobalAttachmentToLocalGeneratedValidAttachmentList(valid_attachments: any[]) {
    this.attachments = valid_attachments;
  }

  private buildValidAttachmentList(result: any) {
    const valid_attachments = [];
    let valid_count = 0;
    for (let i = 0; i < result.length; i++) {
      if (this.getFileExtension(result[i]) != undefined) {
        this.setAttachmentInValidAttachmentList(valid_attachments, valid_count, result[i]);
        valid_count++;
      }
    }
    return { valid_attachments, valid_count };
  }

  private setAttachmentInValidAttachmentList(valid_attachments: any[], valid_count: number, attachment: any) {
    valid_attachments[valid_count] = attachment;
    valid_attachments[valid_count].CreatedDate = this.convertTime(valid_attachments[valid_count].CreatedDate);
  }

  private getFileExtension(attachment) {
    return /[.]/.exec(attachment.Name) ? /[^.]+$/.exec(attachment.Name) : '';
  }

  private setupGetAttachmentListApiDataParameter() {
    const salesforce_data = this.dataService.getSalesforceData();
    return {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      record_id: salesforce_data.record_id
    };
  }

  private checkIfPreselectedAttachmentIsProvided() {
    const selected_attachment_id = this.dataService.getUrlParamater('attachment_id');
    let attachment_selected = false;
    if (selected_attachment_id != '' && selected_attachment_id.length > 0) {
      attachment_selected = true;
    }
    return { attachment_selected, selected_attachment_id };
  }

  private getAttachmentList(data: { sf_token: string; instance_url: string; record_id: string }) {
    return this.dataService.apiPostCall('/api/get_attachment_list', data);
  }

  private generateDateTimeString(min: number, date: number, month: number, year: number, hour: number) {
    let time = date + '/' + month + '/' + year + ' ' + hour;
    if (min < 10) {
      time += ':0' + min;
    } else {
      time += ':' + min;
    }
    return time;
  }

  private getDateTimeParametersGivenTimeStamp(timestamp: any) {
    const dateTime = new Date(timestamp + ' UTC');
    let { month, min, date, year, hour } = this.givenDataTimeSetDateParameters(dateTime);
    month = this.shiftMonthByOne(month);
    return { month, min, date, year, hour };
  }

  private shiftMonthByOne(month: number) {
    // Month Range Converted From 0 - 11 To 1 - 12
    month++;
    return month;
  }

  private givenDataTimeSetDateParameters(dateTime: Date) {
    const year = dateTime.getFullYear();
    const month = dateTime.getMonth();
    const date = dateTime.getDate();
    const hour = dateTime.getHours();
    const min = dateTime.getMinutes();
    return { month, min, date, year, hour };
  }

  private postAttachmentToSignNowAndProcessResponse(
    data:
      | {
          sf_token: string;
          instance_url: string;
          contentDocument_id: any;
          file_name: any;
          content_type: any;
          file_attachment: boolean;
        }
      | {
          sf_token: string;
          instance_url: string;
          attachment_id: any;
          attachment_name: any;
          attachment_content_type: any;
          file_attachment: boolean;
        }
  ) {
    this.postAttachmentToSignNow(data).subscribe((_result) => {
      this.processPostAttachmentToSignNowResult(_result);
    }, this.displayApiErrorResponse());
  }

  private initAndSetupPostToAttachmentSignNowApiDataParameter(attachment: any) {
    const { contentDocument_id, file_name, content_type } =
      this.initSendAttachmentToSignNowLocalFunctionVariables(attachment);
    const data = this.setupPostAttachmentToSignNowDataObject(
      attachment,
      contentDocument_id,
      file_name,
      content_type
    );
    return data;
  }

  private initSendAttachmentToSignNowLocalFunctionVariables(attachment: any) {
    const contentDocument_id = attachment.Id;
    const file_name = attachment.Name;
    const content_type = null;
    return { contentDocument_id, file_name, content_type };
  }

  private setupPostAttachmentToSignNowDataObject(
    attachment: any,
    contentDocument_id: any,
    file_name: any,
    content_type: any
  ) {
    if (attachment.type === 'file') {
      return this.configureTypeFilePostAttachmentToSignNowDataObject(
        contentDocument_id,
        file_name,
        content_type
      );
    } else {
      return this.configureTypeAttachmentPostAttachmentToSignNowDataObject(attachment);
    }
  }

  private configureTypeFilePostAttachmentToSignNowDataObject(
    contentDocument_id: any,
    file_name: any,
    content_type: any
  ) {
    const salesforce_data = this.dataService.getSalesforceData();
    const data = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      contentDocument_id: contentDocument_id,
      file_name: file_name,
      content_type: content_type,
      file_attachment: true
    };
    return data;
  }

  private configureTypeAttachmentPostAttachmentToSignNowDataObject(attachment: any) {
    const salesforce_data = this.dataService.getSalesforceData();
    const { attachment_id, attachment_name, attachment_content_type } =
      this.setAttachmentDataToVariables(attachment);
    const data = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      attachment_id: attachment_id,
      attachment_name: attachment_name,
      attachment_content_type: attachment_content_type,
      file_attachment: false
    };
    return data;
  }

  private setAttachmentDataToVariables(attachment: any) {
    const attachment_id = attachment.Id;
    const attachment_name = attachment.Name;
    const attachment_content_type = attachment.ContentType;
    return { attachment_id, attachment_name, attachment_content_type };
  }

  private processPostAttachmentToSignNowResult(result: any) {
    result = this.getIdFromResultAndSetIdInTheDataService(result);
    this.stopLoadingRedirectToNextStage();
    return result;
  }

  private getIdFromResultAndSetIdInTheDataService(result: any) {
    const id = this.getIdFromResult(result);
    this.setDocumentIdInDataService(id);
    return result;
  }

  private getIdFromResult(result: any) {
    return result.id;
  }

  private setDocumentIdInDataService(id: string) {
    this.dataService.setDocumentId(id);
  }

  private displayApiErrorResponse(): (error: any) => void {
    return (error) => {
      this.updateLoading(false, '');
      if (error.status === 503 || error.status === 504) {
        this.updateError('Call timed out.');
      } else {
        this.updateError(error.error);
      }
    };
  }

  private stopLoadingRedirectToNextStage() {
    this.updateLoading(false, '');
    const link = ['attachments-group-options'];
    this.router.navigate(link).then(
      function () {},
      function () {}
    );
  }

  private postAttachmentToSignNow(data: any) {
    return this.dataService.apiPostCall('/api/post_attachment_to_signnow', data);
  }

  private resetSignNowUserData() {
    this.user_data.sn_token = '';
    this.user_data.sn_refresh = '';
    this.user_data.sn_email = '';
  }

  private stopLoadingAndSetLoginRequiredToTrue() {
    this.loginRequired();
  }

  private loginToSignNow(login_data: { username: any; password: any }) {
    return this.dataService.apiPostCall('/api/login_to_signnow', JSON.stringify(login_data));
  }

  private processLoginToSignNowResult(result: any, email: any) {
    this.updateLoading(true, 'Login with SignNow response returned.');
    if (result.valid_credentials === true) {
      this.validCredentiailsUpdateUserDataSNEmailAndUserDB(result, email);
    } else {
      this.badLoginStopLoadingAndDisplayErrorMessage();
    }
  }

  private badLoginStopLoadingAndDisplayErrorMessage() {
    this.updateLoading(false, '');
    this.updateError('Invalid user credentials. Please enter valid user credentials to log in to SignNow.');
  }

  private validCredentiailsUpdateUserDataSNEmailAndUserDB(loginUserResult: any, email: any) {
    this.userLoggedInClearErrorsSetLoginRequiredToFalse();
    this.configureLoginResultData(loginUserResult, email);
    this.updateLoading(true, 'Validating SignNow login credentials and updating user data on this account.');
    this.updateDBReloadComponent();
  }

  private updateDBReloadComponent() {
    this.updateUserDBGivenUserData().subscribe(() => {
      this.doneUpdatingUserDbReloadComponent();
    });
  }

  private updateUserDBGivenUserData() {
    return this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
  }

  private configureLoginResultData(loginUserResult: any, email: any) {
    const sn_token = loginUserResult.sn_token;
    const sn_refresh = loginUserResult.sn_refresh;
    this.setUserDataSNTokenRefreshAndEmail(sn_token, sn_refresh, email);
    this.dataService.setSignNowOwnerEmail(email);
  }

  private setUserDataSNTokenRefreshAndEmail(sn_token: any, sn_refresh: any, email: any) {
    this.user_data.sn_token = sn_token;
    this.user_data.sn_refresh = sn_refresh;
    this.user_data.sn_email = email;
  }

  private userLoggedInClearErrorsSetLoginRequiredToFalse() {
    this.clearErrors();
    this.login = false;
  }

  private doneUpdatingUserDbReloadComponent() {
    this.updateLoading(false, '');
    this.reload();
  }

  reloadAfterSSOLogin() {
    this.login = false;
    this.reload();
  }
}
